import { API } from '../../../common/api'
import { ignoreNotFound } from '../errorDisposition'
import {
  crmServiceUrl,
  intelligenceServiceUrl,
  labravAWSEngineServiceUrl,
} from '../../../common/utils/constants'
import {
  CosellReferralType,
  CosellReferralBy,
} from '../../../oppsync/modules/CoSell/actions'

export * from './azure'

export const fetchReferrals = (
  partnerId: string,
  pageSize?: number,
  pageNumber?: number,
  referralType?: CosellReferralType,
  referralBy?: CosellReferralBy,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc',
  filters?: Record<string, string>
) =>
  API.get(`${crmServiceUrl}/partners/${partnerId}/referrals`, {
    params: {
      referral_type:
        referralType === 'opportunity'
          ? 'referral_opportunity'
          : 'referral_lead',
      referred_by: referralBy === 'ace' ? 'AWS Referral' : 'Partner Referral',
      page_size: pageSize,
      page_number: pageNumber,
      sort_By:
        sortBy === 'targetCloseDate' ? 'Labra__Target_Close_Date__c' : sortBy,
      sort_order: sortOrder,
      ...filters,
    },
    classifyError: ignoreNotFound,
  })

export const fetchAWSReferrals = (
  partnerId: string,
  pageSize?: number,
  pageNumber?: number,
  referralType?: CosellReferralType,
  referralBy?: CosellReferralBy,
  sortBy?: string,
  companyName?: string,
  objectId?: string,
  crmId?: string,
  cloudId?: string,
  sortOrder?: 'asc' | 'desc',
  filters?: Record<string, string>
) => {
  return API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals`,
    {
      params: {
        object_type: referralType,
        page_size: pageSize,
        page_number: pageNumber,
        sort_order: sortOrder,
        sort_by: sortBy,
        referred_by: referralBy === 'crm' ? 'partner' : referralBy,
        company_name: companyName,
        object_id: objectId,
        crm_id: crmId,
        cloud_id: cloudId,
        ...filters,
      },
      classifyError: ignoreNotFound,
    }
  )
}
export const fetchMetrics = (partnerId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/metrics`
  )

export const fetchTestOpportunity = (partnerId: string, referralId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/sandbox/referrals/${referralId}`
  )

export const putTestOpportunity = (
  partnerId: string,
  referralId: string,
  data: object
) =>
  API.put(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/sandbox/referrals/${referralId}`,
    data
  )

export const fetchPartnerCentralUsers = (partnerId: string) =>
  API.get(`${crmServiceUrl}/partners/${partnerId}/partner-central-users`)

export const fetchCRMfiels = (crmId: string, templateId?: string) =>
  API.get(
    `${crmServiceUrl}/crms/${crmId}/tables/Labra__Labra_Referral__c/fields`,
    {
      params: {
        template_id: templateId,
      },
    }
  )
export const createTestOpportunity = (partnerId: string) =>
  API.post(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/sandbox/referrals`
  )

export const approveTestOpportunity = (partnerId: string) =>
  API.put(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/sandbox/referrals/approve`
  )
export const reSyncReferralAPI = (partnerId: string, referralId: string) =>
  API.post(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/${referralId}/re-syncs`
  )
export const fetchSolutions = (partnerId: string) =>
  API.get(`${labravAWSEngineServiceUrl}/partners/${partnerId}/solutions`)

export const fetchAwsOpportunity = (
  partnerId: string,
  aceOpportunityId: string
) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/aws-opportunity/${aceOpportunityId}`
  )

export const fetchDashboardMetricsAPI = (partnerId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/dashboard-metrics`
  )

export const fetchAgentRecommendationsAPI = (partnerId: string) =>
  API.get(
    `${intelligenceServiceUrl}/partners/${partnerId}/agent-recommendations`
  )

export const sendTestAutomatedEmailCorrespondence = (
  partnerId: string,
  data: { email_address: string; notification_type: string }
) =>
  API.post(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/test-automated-email-correspondence`,
    data
  )
